import styled from "styled-components";
import { theme } from "../../theme/semanticTheme";
import { getVariantStyles, getSizeStyles, getStateStyles } from "./Button.variants";

/**
 * Base styled button – all styling comes from variants utility.
 * Renders as button, anchor, or custom component via "as" prop.
 */
export const StyledButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${theme.spacing.sm};
  font-family: ${theme.typography.fontFamily};
  font-weight: ${theme.typography.fontWeight.medium};
  line-height: 1.25;
  text-decoration: none;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, opacity 0.15s ease,
    box-shadow 0.15s ease;
  outline: none;
  box-sizing: border-box;

  &:focus-visible {
    box-shadow: 0 0 0 2px ${theme.colors.purple};
  }

  ${(p) => getVariantStyles(theme, p.$variant)}
  ${(p) => getSizeStyles(theme, p.$size)}
  ${(p) =>
    getStateStyles(theme, {
      disabled: p.$disabled,
      loading: p.$loading,
      fullWidth: p.$fullWidth,
      rounded: p.$rounded,
      elevated: p.$elevated,
      animation: p.$animation,
    })}

  ${(p) =>
    p.$disabled || p.$loading
      ? `
        background: ${theme.colors.border};
        border-color: ${theme.colors.border};
        color: ${theme.colors.textMuted};
        box-shadow: none;
      `
      : ""}
`;

export const IconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const SpinnerWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1em;
  height: 1em;
  font-size: inherit;
  animation: button-spin 0.7s linear infinite;

  @keyframes button-spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
